import { render } from "./WebFooter.vue?vue&type=template&id=53e2c5a6&scoped=true"
const script = {}

import "./WebFooter.vue?vue&type=style&index=0&id=53e2c5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e2c5a6"]])

export default __exports__